import {
  AddCircle,
  DeleteElement, DocumentTable, HtmlTooltip,
  SimpleModal, TextToolTip,
} from 'components';
import {
  useGlobalText, useModal,
} from 'utils';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  customerPaymentActions,
  httpRequestsOnErrorsActions,
  httpRequestsOnLoadActions,
  httpRequestsOnSuccessActions,
} from 'store';
import { authService } from '../../../store/customerPayment/customerPayment.service';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CustomerInfoEdit } from './customerInfoEdit';
import { AddOrder } from './addOrder';
import { PmtLoads } from './pmtLoads';
import moment from 'moment/moment';

const ADD_PMT_DOCK = 'ADD_PMT_DOCK';
const DELETE_PMT_DOCK = 'DELETE_PMT_DOCK';
const EDIT_PMT_DOCK = 'EDIT_PMT_DOCK';
const CUSTOMER_PAYMENT_VOIDED = 'CUSTOMER_PAYMENT_VOIDED';

export const CustomerPaymentInfoFragment = ({ info, customerPaymentLoad, pmtId, afterSuccess }) => {
  const globalStyle = useGlobalText();
  const dispatch = useDispatch();
  const [openVoid, setOpenVoid] = useState(false);
  const [loadVoid, setLoadVoid] = useState(false);
  const [addLoad, setAddLoad] = useState(false);
  const [expanded, setExpanded] = useState('');
  const { open } = useModal();
  const handleOpenCloseDelModal = () => {
    setOpenVoid(!openVoid);
  };
  const handleVoidPayment = async () => {
    dispatch(httpRequestsOnErrorsActions.removeError(CUSTOMER_PAYMENT_VOIDED));
    setLoadVoid(true);
    try {
      await authService.voidCustomerService(info?.id);
      dispatch(customerPaymentActions.getCustomerPaymentById(pmtId, 'noLoad'));
      dispatch(customerPaymentActions.getCustomerPaymentLoad(pmtId, ));
      setLoadVoid(false);
      dispatch(httpRequestsOnSuccessActions.appendSuccess('VOID_CUSTOMER_PAYMENT_SUCCESS'));
      afterSuccess();
      setOpenVoid(false);
    } catch (e) {
      dispatch(httpRequestsOnErrorsActions.appendError(CUSTOMER_PAYMENT_VOIDED));
      setLoadVoid(false);
      setOpenVoid(false);
    }
  };
  const handleAddDocument = async (img) => {
    try {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ADD_PMT_DOCK));
      await authService.addCustomerPaymentDocument(img, info.id);
      dispatch(httpRequestsOnSuccessActions.appendSuccess(ADD_PMT_DOCK));
      dispatch(httpRequestsOnLoadActions.removeLoading(ADD_PMT_DOCK));
      dispatch(customerPaymentActions.getCustomerPaymentById(pmtId, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(ADD_PMT_DOCK));
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ADD_PMT_DOCK));
    }
  };
  const handleDeleteFile = async (doc) => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(DELETE_PMT_DOCK));
      await authService.deleteCustomerPaymentDocument(info.id, doc?.id);
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_PMT_DOCK));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(DELETE_PMT_DOCK));
      dispatch(customerPaymentActions.getCustomerPaymentById(pmtId, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_PMT_DOCK));
    }
  };
  const handleSetDocStatus = async (doc, type) => {
    try {
      dispatch(httpRequestsOnLoadActions.appendLoading(EDIT_PMT_DOCK));
      const info = {
        ...doc,
        status: type !== 'edit' ? doc.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' : doc.status,
      };
      await authService.setPmtDocumentStatus(pmtId, doc.id, info);
      dispatch(httpRequestsOnLoadActions.removeLoading(EDIT_PMT_DOCK));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(EDIT_PMT_DOCK));
      dispatch(customerPaymentActions.getCustomerPaymentById(pmtId, 'noLoad'));
    } catch (e) {
      dispatch(httpRequestsOnLoadActions.removeLoading(EDIT_PMT_DOCK));
    }
  };

  return (
    <div className="accordion-style">

      <Accordion
        expanded={expanded === 'payment'}
        onChange={() => setExpanded(expanded === 'payment' ? '' : 'payment')}
      >
        <AccordionSummary
          className={'accordion'}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div
            style={{ gap: 16 }}
            className="flex-align-center full-width"
          >
            <ExpandMoreIcon style={{ transform: expanded === 'payment' ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            <p className={globalStyle.title}>Payment Information</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <CustomerInfoEdit />
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'orders'} onChange={() => setExpanded(expanded === 'orders' ? '' : 'orders')}>
        <AccordionSummary
          className={'accordion'}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div
            style={{ gap: 16 }}
            className="flex-align-center full-width"
          >
            <ExpandMoreIcon style={{ transform: expanded === 'orders' ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            <p className={globalStyle.title}>Orders</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="full-width" style={{ padding: '24px 16px' }}>
            <div className="flex-end" style={{ zIndex: 10, position: 'relative' }}>
              {!info?.customerId ?
              <HtmlTooltip title={<div>To add an order, please edit the payment and assign a customer first.</div>} placement="top-end">
               <div style={{opacity: 0.5}}>
                <AddCircle disabled={true} text={'Orders'} />
               </div>
              </HtmlTooltip>
              :
              (!info?.miscellaneous && info?.status === "OPEN") &&
                <AddCircle
                  text={'Orders'}
                  handleCLic={() => open(
                    <AddOrder
                      customerPaymentLoad={customerPaymentLoad}
                      loadDebt={info}
                      closeModal={() => setAddLoad(!addLoad)}
                      handleOpenClose={() => setAddLoad(!addLoad)}
                    />,
                  )}
                />
              }
            </div>

            <PmtLoads/>
          </div>
        </AccordionDetails>
      </Accordion>

      <Accordion expanded={expanded === 'documents'}
                 onChange={() => setExpanded(expanded === 'documents' ? '' : 'documents')}>
        <AccordionSummary
          className={'accordion'}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div style={{ gap: 16 }} className="flex-align-center full-width">
            <ExpandMoreIcon style={{ transform: expanded === 'documents' ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            <p className={globalStyle.title}>Documents</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="full-width" style={{ padding: '24px 16px' }}>
            <DocumentTable
              allDocs={info?.documents}
              deleteDocAction={DELETE_PMT_DOCK}
              handleDeleteDocument={handleDeleteFile}
              addLoadAction={ADD_PMT_DOCK}
              handleUploadFile={handleAddDocument}
              handleChangeStatus={handleSetDocStatus}
              changeStatusAction={EDIT_PMT_DOCK}
              allowSwitchStatus
            />
          </div>
        </AccordionDetails>
      </Accordion>

      <SimpleModal
        handleOpenClose={handleOpenCloseDelModal}
        openDefault={openVoid}
        content={
          <DeleteElement
            loading={loadVoid}
            type={'void'}
            text={'Are you sure you want to void this payment?'}
            handleClose={handleOpenCloseDelModal}
            handleDel={handleVoidPayment}
            info={'Bill'}
            modalText={'This action will undo everything that payment application caused.'}
          />
        }
      />
    </div>
  );
};